import React, { useEffect, useRef, useState } from "react"; 
import { httpCreateSubSkill,httpUpdateSubSkill,getSkillByDeptID } from "../subSkills/api/calls";
import { useDispatch } from "react-redux";
import { fetchSubSkills } from "../../../../Redux/Actions/subSkillAction";

const AddPopupModel = ({departments,skillArr,skillID,setSelectedSkill}) =>{
  console.log(skillID)
    const dispatch = useDispatch();
    const cancelRef = useRef(null);
    const initialValues = {
      skill_name: "",
      group_id: "",
      dept_id: "",
    };
    const [values, setValues] = useState(initialValues);
    const [SkillsetArr, setSelectedSkillSet] = useState([]);
    const [departmentId, setdepartmentId] = useState('');
   
  
    const handleChange =  (e) => {
      const { name, value } = e.target;
      setValues({ ...values, [name]: value });
      
    };
    
    useEffect( () => {
      if (skillID) setValues(skillID);
      
    }, [skillID]);
  
    const handleCancel = () => {
      setSelectedSkill(null);
      setValues(initialValues);
    };
    const handleChangeDepartment = async (e) =>{
     const depId = e.target.value;
      
      setdepartmentId(depId)
      console.log(departmentId)
    await getSkillByDeptID(depId).then((res) =>{
      // console.log('res');
      // console.log(res);
      if (res.status) {
        setSelectedSkillSet(res.data);
      }else{
        setSelectedSkillSet([]);
      }
            
      })

    }
    const handleSubmit = () => {
      if (skill_name === "" || group_id === "" )
        return alert("All fields are required");
      httpCreateSubSkill({name:skill_name,group_id:group_id}).then((res) => {
        if (res.status) {
          setValues(initialValues);
          cancelRef.current.click();
          dispatch(fetchSubSkills());
          return alert(res.msg);
        } else {
          return alert(res.msg);
        }
      });
    };
  
    const handleUpdate = async () => {
      if (skill_name === "" || group_id === "" ) return alert("All fields are required");
      const updatedValues = {
        name: values.skill_name,
        group_id: values.group_id,
      };
      
      await httpUpdateSubSkill(skillID.skill_id, updatedValues).then((res) => {
        if (res.status) {
         setValues(initialValues);
          cancelRef.current.click();
         dispatch(fetchSubSkills());
          return alert(res.msg);
        } else {
          return alert(res.msg);
         }
       });
    };
  
  
    const { skill_name, dept_id,group_id } = values;
    return (
        <div
      className="modal fade"
      id="addSkillSet"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <button
              type="button"
              className="float-end btn_close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={cancelRef}
              onClick={handleCancel}
            >
              <i className="icon icon-cross"></i>
            </button>
            <div
              className="dash_white_box_ttl text-center"
              id="exampleModalLabel"
            >
              {skillID ? "Update" : "Add"} Sub Skill Set
            </div>
            <form>
            {skillID ?
            <div className="mb-2">
            <label className="col-form-label">Skill Set</label>
            <select
              type="text"
              className="form-select"
              name="group_id"
              value={group_id}
              onChange={handleChange}
            >
              <option value={""}>Select Skill</option>
              {skillArr &&
                skillArr?.map((skillItem, i) => {
                  return (
                    <option key={i} value={skillItem.group_id}>
                      {skillItem.group_name}
                    </option>
                  );
                })}
            </select>
          </div>
            :
            <>
            <div className="mb-2">
            <label className="col-form-label">Department</label>
            <select
              type="text"
              className="form-select"
              name="departmentId"
              value={departmentId}
              onChange={handleChangeDepartment}
            >
              <option value={""}>Select Department</option>
              {departments &&
                departments?.map((dept, i) => {
                  return (
                    <option key={i} value={dept.id}>
                      {dept.name}
                    </option>
                  );
                })}
            </select>
          </div>
            <div className="mb-2">
                  <label className="col-form-label">Skill Set</label>
                  <select
                    type="text"
                    className="form-select"
                    name="group_id"
                    value={group_id}
                    onChange={handleChange}
                  >
                    <option value={""}>Select Skill</option>
                    {SkillsetArr &&
                      SkillsetArr?.map((skillItem, i) => {
                        return (
                          <option key={i} value={skillItem.id}>
                            {skillItem.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
            </>
          }
              <div className="mb-2">
                <label className="col-form-label">Sub Skill Name</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={handleChange}
                  name="skill_name"
                  value={skill_name}
                />
              </div>
            </form>
            <div className="modalfooter">
              <button
                type="button"
                className="btn_6 float-end ml10"
                data-bs-dismiss="modal"
                ref={cancelRef}
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                 onClick={skillID ? handleUpdate : handleSubmit}
                type="button"
                className="btn_5 float-end "
              >
                {skillID ? "Update" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
};
export default AddPopupModel;